import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const CalorieFireIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 51 51" {...props}>
      <rect
        opacity="0.1"
        width="51"
        height="51"
        rx="25.5"
        fill={colors.secondary}
      />
      <path
        d="M24.9997 39.75C23.1211 39.7498 21.2859 39.1853 19.7321 38.1296C18.1782 37.074 16.9773 35.5758 16.2851 33.8294C15.5929 32.083 15.4414 30.169 15.85 28.3354C16.2587 26.5018 17.2088 24.8333 18.5772 23.5462C20.2547 21.9675 24.3747 19.125 23.7497 12.875C31.2497 17.875 34.9997 22.875 27.4997 30.375C28.7497 30.375 30.6247 30.375 33.7497 27.2875C34.0872 28.2537 34.3747 29.2925 34.3747 30.375C34.3747 32.8614 33.387 35.246 31.6288 37.0041C29.8707 38.7623 27.4861 39.75 24.9997 39.75Z"
        fill={colors.secondary}
      />
    </SvgIcon>
  );
};

export default CalorieFireIcon;
